import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class provisionalmarksheet{
  StudentProvisionalMarksheetID: number;
  StudentID: number;
  FormNo: string;
  RequestDate: string;
  ExamInstanceID: number;
  CoursePartID: number;
  BranchID: number;
  CollegeID: number;
  TransferCollegeID: number;
  ApplicationFees: number;
  ApplicationFeesReceivedDate: string;
  ApplicationDDNO: string;
  ApplicationBankName: string;
  ApplicationBankDDDate: string;
  provisionalmarksheetRemark:string;
  PaymentMode:string;
  ApplicationStatus: string;
  ApplicationDDConfirm: string;
  ApprovedFlag: string;
  ApprovalDate:string;
  ApprovalRemark: string;
  DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  
}
@Injectable({
  providedIn: 'root'
})
export class ProvisionalmarksheetService {

  constructor(
    private dataService: DataAccessService) {
  }
  public save(data) {debugger
    this.dataService.setControllerName = '/PortalStudentProvisionalMarksheet/';
    this.dataService.setMethodName = 'PostInsertPortalStudentProvisionalMarksheet'; 
    return this.dataService.add<provisionalmarksheet[]>(data) 
  }

  public GetDataforProvisionalMarksheetList(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentProvisionalMarksheet/';
    this.dataService.setMethodName = 'GetDataforProvisionalMarksheetList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<provisionalmarksheet[]>()
  }

  public CheckProvisionalStatusForNewRequest(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentProvisionalMarksheet/';
    this.dataService.setMethodName = 'CheckProvisionalStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<provisionalmarksheet[]>()
  }

  public GetUpdatePaymentStatusForProvisionalMarksheet(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusForProvisionalMarksheet?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
    return this.dataService.getAll<provisionalmarksheet[]>()
  }
  public CancelProvisionalMarksheet(RequestID,StudentID,AcademicInstanceID,ResultQueryCode) {
    this.dataService.setControllerName = '/PortalStudentProvisionalMarksheet/';
    this.dataService.setMethodName = 'CancelProvisionalMarksheet?RequestID='+RequestID+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
    return this.dataService.getAll<provisionalmarksheet[]>()
  }
  public GetClassIDByStudentID(StudentID,ExamInstanceID,CoursePartID ,BranchID) {
    this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
    this.dataService.setMethodName = 'GetClassIDByStudentID?StudentID='+StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID; // setting method name from API controller.
    return this.dataService.getAll<provisionalmarksheet[]>()
  }
  public GetDocumentPathForProvisional(ApplicationNO,ExamInstanceID) {
    this.dataService.setControllerName = '/PortalStudentProvisionalMarksheet/';
    this.dataService.setMethodName = 'GetDocumentPathForProvisional?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<provisionalmarksheet[]>()
  }
}
